<template>
  <DashboardMotivation />
</template>

<script>
import DashboardMotivation from "../../components/DashboardMotivation";
export default {
  name: "FIGUREITOUT",
  components: {
    DashboardMotivation,
  },
};
</script>